import { createOpenAI } from "@ai-sdk/openai";

export interface CaiAgentConfig {
  baseURL: string;
  modelId: string;
  getToken: () => Promise<string>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tools: Record<string, any>;
  maxSteps?: number;
}

/**
 * Create the AI SDK OpenAI-compatible provider with MSAL token injection.
 */
export function createCaiProvider(config: {
  baseURL: string;
  getToken: () => Promise<string>;
}) {
  return createOpenAI({
    baseURL: config.baseURL,
    apiKey: "msal-bearer",
    fetch: async (url: RequestInfo | URL, init?: RequestInit) => {
      const token = await config.getToken();
      const headers = new Headers(init?.headers as HeadersInit);
      headers.set("Authorization", `Bearer ${token}`);
      return fetch(url, { ...init, headers });
    },
  });
}
